import { Component, OnInit, Input } from '@angular/core';
import { OHNElement } from '../../../models/ohn-instances';

@Component({
  selector: 'app-select-element-config',
  templateUrl: './select-element-config.component.html',
  styleUrls: ['./select-element-config.component.scss'],
})
export class SelectElementConfigComponent implements OnInit {

	@Input() el: OHNElement;

  constructor() { }

  ngOnInit() {}

}
